/**
 * Рефреш токена (POST /auth/refresh): вспомогательная логика без React и без сети.
 * Сам запрос делает AuthContext — здесь только решения «можно ли» и «пора ли».
 *
 * Токены сейчас бессрочные, рефреш нужен, чтобы в токен попали свежие role/scope.
 */

/** Не чаще раза в час на платформу: токены бессрочные, а лимит ручки — 20 запросов в минуту. */
export const REFRESH_INTERVAL_MS = 60 * 60 * 1000;

const REFRESHED_AT_PREFIX = 'ssmm-token-refreshed-at-';

export const refreshedAtKey = (platform: string): string => `${REFRESHED_AT_PREFIX}${platform}`;

/** Полезная нагрузка JWT без проверки подписи (подпись проверяет бэк). null — не JWT. */
export const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
  const part = token.split('.')[1];
  if (!part) return null;
  try {
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
    const parsed = JSON.parse(new TextDecoder().decode(bytes));
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : null;
  } catch {
    return null;
  }
};

/**
 * Бэк рефрешит только обычные пользовательские токены. Со сроком (exp), выпущенные админом (issuedBy)
 * и сервисные он отклоняет (403 NOT_REFRESHABLE) — не тратим на них запрос.
 * Токен с act (вход в чужой аккаунт) обновляется, это штатный случай.
 */
export const isRefreshableToken = (token: string): boolean => {
  const payload = decodeJwtPayload(token);
  if (!payload) return false;
  if (typeof payload.uid !== 'string' || !payload.uid) return false;
  if (payload.type === 'service') return false;
  if (payload.exp !== undefined || payload.issuedBy) return false;
  return true;
};

/** Пора ли обновлять: ни разу не обновляли или прошёл интервал. Битая отметка — тоже пора. */
export const isRefreshDue = (lastRefreshedAt: string | null, now: number, intervalMs = REFRESH_INTERVAL_MS): boolean => {
  if (!lastRefreshedAt) return true;
  const last = Number(lastRefreshedAt);
  if (!Number.isFinite(last)) return true;
  // Часы ушли назад (last в будущем) — тоже обновляем, иначе проверка зависла бы надолго.
  return last > now || now - last >= intervalMs;
};
